export default "__VITE_ASSET__D$6DO79n__"